export default (state, loadingValue) => {
    state.currentPostIsLoading = loadingValue
}
